// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"5cb255faf8995d77","5763":"d266fd79fed351a8","6893":"41fea6f32ddcb372","6974":"3dca42e23bf991c7","7222":"329bee8096d09424","7937":"cd9def4e9691e3c5"}[chunkId] + ".js";
};